import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CorrectionInvoiceList from '../components/CorrectionInvoiceList';
import CorrectionInvoiceModal from '../components/CorrectionInvoiceModal';
import { useTranslation } from '../hooks/useTranslation';

const CorrectionInvoices: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateCorrection = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  if (!companyId) {
    return (
      <div className="text-center py-8">
        <p className="text-red-600">{t('common.error')}</p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              {t('correctionInvoices.title')}
            </h1>
            <p className="mt-2 text-gray-600">
              {t('correctionInvoices.description')}
            </p>
          </div>
          <button
            onClick={handleCreateCorrection}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            {t('correctionInvoices.createCorrection')}
          </button>
        </div>
      </div>

      <CorrectionInvoiceList 
        key={refreshKey}
        companyId={companyId} 
      />

      <CorrectionInvoiceModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSuccess={handleSuccess}
        companyId={companyId}
      />
    </div>
  );
};

export default CorrectionInvoices;

